<template>
    <el-dialog :title="title" :visible.sync="visibleSync" :close-on-click-modal="false" :width="width" :destroy-on-close="true" v-if="visibleSync">
        <div :style="getstyle()">
            <slot></slot>
        </div>
        <div slot="footer" class="dialog-footer" v-if="footerVisible">
            <el-button type="info" style="float: left;" @click="Print" v-if="printVisible">打 印</el-button>

            <el-button type="danger" @click="Delete" v-if="delVisible">删 除</el-button>
            <el-button @click="visibleSync = false">取 消</el-button>
            <el-button type="primary" @click="Confirm" v-if="okVisible">确 定</el-button>
            <el-button type="primary" @click="SaveAndPrint" v-if="saveAndPrintVisible">确定并打印</el-button>
        </div>
    </el-dialog>
</template>

<script>
import ItemInput from './ItemInput'
import { mapGetters } from 'vuex'

export default {
    name: `CusDialogNoDrag`,
    components: { ItemInput },
    props: {
        visible: Boolean,
        title: String,
        emit: {
            type: String,
            default: `confirm`
        },
        del: {
            type: String,
            default: `delete`
        },
        print: {
            type: String,
            default: `print`
        },
        saveAndPrint: {
            type: String,
            default: `saveAndPrint`
        },
        width: {
            type: String,
            default: `50%`
        },
        footerVisible: {
            type: Boolean,
            default: true
        },
        okVisible: {
            type: Boolean,
            default: true
        },
        saveAndPrintVisible: {
            type: Boolean,
            default: false
        },
        delVisible: {
            type: Boolean,
            default: false
        },
        printVisible: {
            type: Boolean,
            default: false
        },
        overflow: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            emitName: this.emit,
            delName: this.del,
            printName: this.print,
            saveAndPrintName: this.saveAndPrint
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        }
    },
    methods: {
        getstyle() {
            let h = this.screenHeight - 200
            let r = typeof winformMsg
            if (r != `undefined`) {
                h = this.screenHeight - 200 - 66
            }
            if (this.overflow) {
                return { 'max-height': `${h}px`, overflow: `auto` }
            } else {
                return { 'max-height': `${h}px` }
            }
        },
        Confirm() {
            let that = this
            that.$emit(that.emitName, {})
        },
        Delete() {
            let that = this
            that.$emit(that.delName, {})
        },
        Print() {
            let that = this
            that.$emit(that.printName, {})
        },
        SaveAndPrint() {
            let that = this
            that.$emit(that.saveAndPrintName, {})
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/CusDialogNoDrag.vue